import React from "react";
import PropTypes from "prop-types";
import { Card, Button } from "react-bootstrap";
import "./ProductCard.css";

export default function ProductCard({ product, isInCart, addToCart, removeFromCart }) {
  const { product_id, name, description, price, stock, imageUrl } = product;

  // Fallback image logic
  const fallbackImage = `https://via.placeholder.com/300x180.png?text=${encodeURIComponent(name)}`;
  const resolvedImage =
    imageUrl || `https://source.unsplash.com/300x180/?${encodeURIComponent(name)}&random=${product_id}`;

  // Safe price formatting
  const formatPrice = (value) => {
    const num = typeof value === "number" ? value : parseFloat(value);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };

  // Safe stock fallback
  const safeStock = typeof stock === "number" ? stock : 0;

  return (
    <Card className="product-card mb-4 shadow-sm bg-dark text-light border-secondary">
      <Card.Img
        variant="top"
        src={resolvedImage}
        alt={`Image of ${name}`}
        className="product-card__image"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = fallbackImage;
        }}
      />
      <Card.Body>
        <Card.Title className="product-card__title text-light">{name}</Card.Title>
        <Card.Text className="product-card__description text-secondary">
          {description || "No description available."}
        </Card.Text>
        <Card.Text className="product-card__price fw-bold text-warning">
          R {formatPrice(price)}
        </Card.Text>

        <Button
          variant={isInCart ? "outline-warning" : "warning"}
          className="text-dark fw-semibold"
          onClick={() =>
            isInCart ? removeFromCart(product_id) : addToCart(product)
          }
          aria-label={`${isInCart ? "Remove" : "Add"} ${name} ${isInCart ? "from" : "to"} cart`}
          disabled={safeStock <= 0}
        >
          {safeStock <= 0
            ? "Out of Stock"
            : isInCart
            ? "Remove from Cart"
            : "Add to Cart"}
        </Button>
      </Card.Body>
    </Card>
  );
}

ProductCard.propTypes = {
  product: PropTypes.shape({
    product_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    stock: PropTypes.number,
    imageUrl: PropTypes.string,
  }).isRequired,
  isInCart: PropTypes.bool.isRequired,
  addToCart: PropTypes.func.isRequired,
  removeFromCart: PropTypes.func.isRequired,
};